if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.quantitySelector = this.querySelector("quantity-input");
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      const quantity = +(formData.get("quantity"));
      const giftProducts = $("#gift-products").serializeArray().map(p=>({id:p.value.split("-")[0],quantity:quantity*p.value.split("-")[1]})).filter(p=>p.id);
      // console.log("GP", giftProducts);
      const isPurchasable = await this.isPurchasableBaseOnProductLimit();

      const isPurchasableGift = await this.isPurchasableBaseOnGiftStock();

      if( !isPurchasable ){
        const limit = JSON.parse(this.form.dataset.limit);
        const errorMsg = `1注文につき${limit.min > 0 ? limit.min + '点から':''}${limit.max > 0 ? limit.max + '点まで': ''}`;
        this.handleErrorMessage(errorMsg);
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return;
      }
      if( !isPurchasableGift ){
        const errorMsg = `ご購入可能な在庫数を超えているため、カートに追加いただけません。`;
        this.handleErrorMessage(errorMsg);
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return;
      }
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          if (giftProducts.length) {
            await $.ajax({
                  url: '/cart/add.js',
                  dataType: 'json',
                  type: 'POST',
                  data: { items: giftProducts }
                });
          }
          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    async isPurchasableBaseOnProductLimit(){
      const id = this.form.elements["id"].value;
      const quantity = Number(this.form.elements["quantity"].value);
      const limit = JSON.parse(this.form.dataset.limit);
      const request = await fetch("/cart.js");
      const cart = await request.json();
      const itemFound = cart.items.find( i => i.id == id);
      let isPurchasable = true;

      if( itemFound && (Number(limit.max) > 0 || Number(limit.min) > 0) ){
        const totalQuantity = quantity + itemFound.quantity;
        if( 
          ( limit.min && totalQuantity < Number(limit.min) ) ||
          ( limit.max && totalQuantity > Number(limit.max) )
        ){
          isPurchasable = false;
        }
      }

      return isPurchasable;
    }

    async isPurchasableBaseOnGiftStock() {
      const id = this.form.elements["id"].value;
      const request = await fetch("/cart.js");
      const quantity = Number(this.form.elements["quantity"].value);
      const cart = await request.json();
      const itemFound = cart.items.find(i => i.id == id);
      let isPurchasableGift = true;
    
      $('.gift__quantity').each(function(index) {

        const $this = $(this);
        const giftHandle = $this.data('handle') || 
                          $this.attr('data-handle') || 
                          $this.closest('[data-gift-handle]').data('gift-handle');
        
        const giftQuantity = Number($this.val()) || 0;
    
        let grantedElement;
        let grantedValue = 1;
        
        if (giftHandle) {
          grantedElement = $(`.gifts_granted[data-handle="${giftHandle}"]`);
          grantedValue = parseInt(grantedElement.val(), 10) || 1;
        } else {
          grantedElement = $(`.gifts_granted`).eq(index);
          grantedValue = parseInt(grantedElement.val(), 10) || 1;
        }
    
        const requiredQuantity = quantity * grantedValue;
        if (requiredQuantity > giftQuantity) {
          isPurchasableGift = false;
          return false;
        }
        if (itemFound) {
          const totalRequired = (itemFound.quantity + quantity) * grantedValue;
          if (totalRequired > giftQuantity) {
            isPurchasableGift = false;
            return false;
          }
        }
      });
    
      return isPurchasableGift;
    }
  
  });
}
